import AppLayout from "./components/layout/AppLayout";

import Home from "./pages/home";
import Explore from "./pages/explore";
import Shuffle from "./pages/shuffle";
import Booking from "./pages/booking";
import Referral from "./pages/referral";
import Feedback from "./pages/feedback";
import Profile from "./pages/profile";
import RestaurantDashboard from "./pages/restaurant-dashboard";
import HowItWorks from "./pages/how-it-works";
import NotFound from "./pages/not-found";
import AuthPage from "./pages/auth-page";
import { ProtectedRoute } from "./lib/protected-route";
import {Route, Switch} from "wouter";
import BookingFromShuffle from "./components/booking/BookingFromShuffle";
import Faq from "./pages/faq";
import Contact from "./pages/contact";
import Privacy from "./pages/privacy";
import Terms from "./pages/terms";
import Partner from "./pages/partner";
import SuccessStories from "./pages/success-stories";
import Success from "./pages/success";
import Failed from "./pages/failed";
import Activate from "./pages/activate";
import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <AppLayout>
      <ScrollToTop />
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/explore" component={Explore} />
        <Route path="/shuffle" component={Shuffle} />
        <Route path="/how-it-works" component={HowItWorks} />
        <Route path="/auth" component={AuthPage} />
        <Route path="/activate" component={Activate} />
        <Route path="/booking-shuffle" component={BookingFromShuffle} />
        <Route path="/faq" component={Faq} />
        <Route path="/contact" component={Contact} />
        <Route path="/privacy" component={Privacy} />
        <Route path="/terms" component={Terms} />
        <Route path="/partner" component={Partner} />
        <Route path="/success-stories" component={SuccessStories} />
        <Route path="/success" component={Success} />
        <Route path="/failed" component={Failed} />
        <ProtectedRoute path="/booking/:id" component={Booking} />
        <ProtectedRoute path="/referral" component={Referral} />
        <ProtectedRoute path="/feedback" component={Feedback} />
        <ProtectedRoute path="/profile" component={Profile} />
        <ProtectedRoute path="/restaurant-dashboard" component={RestaurantDashboard} />
        <Route component={NotFound} />
      </Switch>
    </AppLayout>
  );
}

export default App;
